import { apiSlice } from '../../app/api/apiSlice'

export const productApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSKUs: builder.query ({
      query: ({page = 1, type = null, family_id = null}) => (
        family_id === null ? (
          type === null ?
            `v2/sku/?name__ne=&ordering=name&page=${page}` :
            `v2/sku/?name__ne=&item_type=${type}&ordering=name&page=${page}`
        ) : (
          type === null ?
            `v2/sku/?name__ne=&product_family=${family_id}&ordering=name&page=${page}` :
            `v2/sku/?name__ne=&item_type=${type}&product_family=${family_id}&ordering=name&page=${page}`
        )),
      keepUnusedDataFor: 5,
    }),
    getAllProductFamilies: builder.query ({
      query: () => `v2/productfamily/?ordering=name`,
      keepUnusedDataFor: 5,
      providesTags: ["ProductFamily"]
    }),
    createProductFamily: builder.mutation ({
      query: ({data}) => ({
        url: `v2/productfamily/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ProductFamily"]
    }),
    getProductsForFamily: builder.query ({
      query: ({family_id, type = null}) =>
        family_id === '_others' ? (
          `v2/orphaned_skus`
        ) : (
          type === null ?
          `v2/sku/?product_family=${family_id}&item_type__in=single,group&ordering=name` :
          `v2/sku/?product_family=${family_id}&item_type=${type}&ordering=name`
        ),
      keepUnusedDataFor: 5,
      providesTags: ["SKU"]
    }),
    getProductById: builder.query ({
      query: (product_id) => `v2/sku/${product_id}/`,
      keepUnusedDataFor: 5
    }),
    findProductByName: builder.query ({
      query: (search) => `v2/sku/?name__ilike=%${search}%`,
      keepUnusedDataFor: 5
    }),
    getSKUChildren: builder.query ({
      query: (sku_id) => `v2/skugroup/?parent=${sku_id}&ordering=id`,
      keepUnusedDataFor: 5
    }),
    updateSKU: builder.mutation ({
      query: ({sku_id, data}) => ({
        url: `v2/sku/${sku_id}/`,
        method: 'PUT',
        body: data
      })
    }),
    createSKU: builder.mutation ({
      query: ({data}) => ({
        url: `v2/sku/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKU"]
    }),
  }),
})


export const {
  useGetAllSKUsQuery,
  useGetAllProductFamiliesQuery,
  useCreateProductFamilyMutation,
  useGetProductsForFamilyQuery,
  useGetProductByIdQuery,
  useFindProductByNameQuery,
  useGetSKUChildrenQuery,
  useUpdateSKUMutation,
  useCreateSKUMutation,
  useGetOrphanProductsQuery
} = productApi
